export enum StarzleBetGroup {
    MAIN_BET,
    PICK6,
    BONUS_NUMBER,
    BONUS,
    EXTRAS,
}
